// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__aIgTR","name":"ConsentHeader_name__jP8Zo","birthday":"ConsentHeader_birthday__2jxk0","skeleton":"ConsentHeader_skeleton__2hsqP"};